<template>
    <div class="text-center">
        <v-bottom-sheet v-model="isOpen" persistent>
            <v-sheet height="380px">
                <v-container fluid class="px-4">
                    <v-row>
                        <v-col>
                            <p class="phone-validate__header">{{ $t("we_send_sms_with_code") }}</p>
                        </v-col>
                    </v-row>

                    <v-row justify="center">
                        <v-col lg="4" md="4" sm="8" xs="10">
                            <v-text-field
                                v-model="code"
                                :label="$t('code_from_sms')"
                                outlined
                                :hint="$t('to_proceed_enter_sms_code')"
                            ></v-text-field>
                            <div v-if="!isCodeResend" class="text-center">
                                <countdown :time="100 * 1000" @end="makeAvailableResend">
                                    <template slot-scope="props">
                                        <a
                                            v-if="!canResend"
                                            class="cant-send"
                                            style="font-size: 13px;"
                                            >{{ $t("dont_get_code") }}
                                            <span>
                                                ({{ props.minutes }}:{{
                                                    parseInt(props.seconds) < 10
                                                        ? "0" + props.seconds
                                                        : props.seconds
                                                }})
                                            </span>
                                        </a>
                                        <a v-if="canResend" @click="resendCode()">
                                            {{ $t("dont_get_code") }}
                                        </a>
                                    </template>
                                </countdown>
                            </div>
                        </v-col>
                    </v-row>
                    <v-row> </v-row>
                    <v-row justify="center">
                        <v-col>
                            <v-btn
                                depressed
                                color="primary"
                                class="w100"
                                dark
                                large
                                @click="validate()"
                                >{{ $t("confirm") }}</v-btn
                            >
                        </v-col>
                    </v-row>
                </v-container>
            </v-sheet>
        </v-bottom-sheet>
        <overlay-loader :show="isLoading"></overlay-loader>
    </div>
</template>

<script>
import moment from "moment";
import VueCountdown from "@chenfengyuan/vue-countdown";
import OverlayLoader from "@/app/shared/components/app-loader/Loader";

export default {
    name: "ValidatePhone",
    components: {
        countdown: VueCountdown,
        OverlayLoader,
    },
    data() {
        return {
            code: "",
            now: Date.now(),
            canResend: false,
            isCodeResend: false,
        };
    },
    created() {
        this.now = Date.now();
    },
    computed: {
        isOpen() {
            return this.$store.getters.IS_PHONE_VALIDATION_OPENED;
        },
        isLoading() {
            return this.$store.getters.IS_PHONE_VALIDATION_LOADING;
        },
    },
    methods: {
        validate() {
            this.$store.dispatch("CHECK_VERIFICATION_CODE", this.code).catch(() => {
                this.$toast.error(this.$t("errors.wrong_code"));
            });
        },
        makeAvailableResend() {
            this.canResend = true;
        },
        resendCode() {
            this.$store
                .dispatch("SEND_PHONE_VERIFICATION_CODE")
                .then(() => {
                    this.$toast.success(this.$t("sms_was_send_again!"));
                    this.isCodeResend = true;
                })
                .catch(() => {
                    this.$toast.error(this.$t("errors.we_cant_send_email"));
                });
        },
    },
};
</script>

<style>
.phone-validate__header {
    margin-top: 10px;
    font-size: 32px;
    font-weight: 200;
}

@media (max-width: 600px) {
    .phone-validate__header {
        font-weight: 500;
        font-size: 20px;
        line-height: 26px;
    }
}

.cant-send {
    text-decoration: none;
    color: #4a4a4a !important;
    cursor: default !important;
}
</style>
